import React, { useState, useEffect } from 'react'
import { Link, Redirect, useParams } from "react-router-dom"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { host, Host } from '../../App';
import Axios from 'axios'
import './Report.css'


const All_requests = () => {
  var [postList, setPostList] = useState([]);
  var [PoNo, setPoNo] = useState({});
  var [poNo, setpoNo] = useState([]);
  var [Item_Desc, setItem_Desc] = useState("");
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState('2025-01-01');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var [Supplier, setSupplier] = useState({});
  var [Status, setStatus] = useState({});
  var [Maintenance_category, setMaintenance_category] = useState("");
  var [Customers, setCustomers] = useState([]);
  var [partNo, setpartNo] = useState([]);
  var [Name, setName] = useState({});
  var [Category_list, setCategory_list] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));
  var Stage = (window.localStorage.getItem("Stage"));
  var Ranked = (window.localStorage.getItem("Rank"));
  var user = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [rank, setrank] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank(true);
    }
  }, [Ranked]);
  const [data, setData] = useState([]);
  const queryParams = {
    token: token,
    Start_date: Postartdate,
    End_date: Poenddate,
    Supplier: JSON.stringify(Supplier),
    Maintenance_category: JSON.stringify(Maintenance_category),
    Name: JSON.stringify(Name),
    Item_Desc: Item_Desc,
    Status: JSON.stringify(Status)
  };

  //var token = sessionStorage.getItem("token");

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/All_Reports/search`, { params: queryParams }).then((data) => {
      setData(data.data);
    })
  }, [Postartdate, Poenddate, Supplier, Maintenance_category, Name, Item_Desc, Stage]);
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/Other_Expenses/pono/${token}`).then((data) => {
      setpoNo(data.data)
    });
  }, [])
  // to retreive customers
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/Other_Expenses/suppliers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/Other_Expenses/itemno/${token}`).then((data) => {
      setpartNo(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/Other_Expenses/Category/${token}`).then((data) => {
      setCategory_list(data.data)
    });
  }, [])
  const search = () => {
    Axios.get(`https://` + Host + `/api/All_Reports/search`, { params: queryParams }).then((data) => {
      setData(data.data);

    })
  }

  const [changedRows, setChangedRows] = useState(new Set());
  const print = () => {
    const changedData = [...changedRows].map(index => {
      return data[index];
    });
    console.log(JSON.stringify(changedData));
  }
  const Approve = (ID) => {
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Maintenance_Request/approve/${ID},${user},${token}`).catch(function (error) {
      console.log(error.response);
    })
    setIsLoading(false);
    setTimeout(function () {
      search();
    }, 2000);
  };
  const Status_Change = (ID, Status) => {
    console.log(Status);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Maintenance_Request/status/${ID},${user},${Status},${token}`).catch(function (error) {
      console.log(error.response);
    })
    setIsLoading(false);
    setTimeout(function () {
      search();
    }, 2000);
  };

  return (
    <div className="MainPage_data">
      <div class="Container">
        <ToastContainer />
        <div class="row">
          <div class="col">
            <div class="row">
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Requested By' list="category" onChange={(e) => {
                setName((e.target.value).replace(/[{""}]/g, ""))
              }} onSelect={search} />
              <datalist id="category">
                <option></option>
                {[...new Set(data.map(x => x.Name))].map((name, index) => (
                  <option key={index}>{name}</option>
                ))}
              </datalist>
            </div>

          </div >
          <div class="col">
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Maintenance Category' list='Maintenance_category' onChange={(e) => {
                setMaintenance_category(e.target.value)
              }} onSelect={search} />
              <datalist id="Maintenance_category">
                <option></option>

                {[...new Set(data.map(x => x.Maintenance_category))].map((Maintenance_category, index) => (
                  <option key={index}>{Maintenance_category}</option>
                ))}
              </datalist>
            </div>
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Issue Description' list="Itemdesc" onChange={(e) => {
                setItem_Desc(e.target.value.replace(/[{"''"}]/g, ''));
              }} onSelect={search} />
              <datalist id="Itemdesc">
                <option></option>
                {[...new Set(data.map(x => x.Issue_Description))].map((Issue_Description, index) => (
                  <option key={index}>{Issue_Description}</option>
                ))}
              </datalist>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col" id='moldng'>
                {/* Grab the Itemicular dates */}
                <input type='date' class="form-control form-rounded" id='supplychain-button' placeholder='Invoice DATE' defaultValue={Postartdate} onChange={(e) => {
                  setPoStartdate(e.target.value)
                }} onSelect={search} />
                {/*<button class="btn btn-success" onClick={dates}>Submit</button > */}
                <span class="tooltiptext">Filter By Request Date </span>

              </div>
              <div class="col">
                <input type='date' class="form-control form-rounded" id='supplychain-button' placeholder='Operator' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
                  setPoEnddate(e.target.value)
                }} onSelect={search} />
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              {/* Grab the Itemicular Supplier */}
              <input type='text' class="form-control form-rounded" placeholder='Agency Name' list='Suppliers' onChange={(e) => {
                setSupplier(e.target.value)
              }} onSelect={search} />
              <datalist id="Suppliers">
                <option></option>
                {[...new Set(data.map(x => x.Agency_name))].map((Agency_name, index) => (
                  <option key={index}>{Agency_name}</option>
                ))}
              </datalist>
            </div>
            <div class="row">
              {/* Grab the Itemicular Supplier */}
              <input type='text' class="form-control form-rounded" placeholder='Status' list='Status' onChange={(e) => {
                setStatus(e.target.value)
              }} onSelect={search} />
              <datalist id="Status">
                <option></option>
                {[...new Set(data.map(x => x.Status))].map((Status, index) => (
                  <option key={index}>{Status}</option>
                ))}
              </datalist>
            </div>
          </div>
        </div >
        <br></br>
        <br></br>
        <div id='RRM_table'>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Request Date</th>
                <th>Email</th>
                <th>Request By</th>
                <th>Maintenance Category</th>
                <th>Equipment Maintenance</th>
                <th>Facility Maintenance</th>
                <th>Issue Description</th>
                <th>Priority</th>
                <th>Tentative Completion Date</th>
                <th>Outside Assistance</th>
                <th>Agency Name</th>
                <th>Comments</th>
                <th>Status</th>
                <th>Approval</th>
                <th>Approved By</th>
                {rank ? <th>Approve</th> : null}
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => {

                return (

                  <tr key={val.ID || index} className={`${val.Status === "Submitted" ? "lightgrey-background" :
                    val.Status === "On hold" ? "red-background" :
                      val.Status === "Read" ? "Yellow-background" :
                        val.Status === "On going" ? "orange-background" :
                          val.Status === "Completed" ? "Green-background" : "white-background"}`}>

                    <td>{val.Request_date ? val.Request_date.slice(0, 10) : ""}</td>
                    <td>{val.Email}</td>
                    <td>{val.Name}</td>
                    <td>{val.Maintenance_category}</td>
                    <td>{val.Equipment_maintenance}</td>
                    <td>{val.Facility_maintenance}</td>
                    <td>{val.Issue_Description}</td>
                    <td>{val.Priority}</td>
                    <td>{val.Tentative_completion_date ? val.Tentative_completion_date.slice(0, 10) : ""}</td>
                    <td>{val.Outside_assistance}</td>
                    <td>{val.Agency_name}</td>
                    <td>{val.Comments}</td>
                    <td><select className="form-control form-rounded" defaultValue={val.Status} onBlur={(e) => {
                      Status_Change(val.ID, e.target.value);
                    }}>
                      <option value="Submitted">Submitted</option>
                      <option value="Read">Read</option>
                      <option value="On going">On going</option>
                      <option value="On hold">On hold</option>
                      <option value="Completed">Completed</option>
                    </select></td>
                    <td>{val.Approval_Status}</td>
                    <td>{val.Approved_By}</td>
                    {rank ? (
                      <td>
                        {val.Approval_Status === 'Awaiting' && (
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              window.confirm('Are you sure you want to Approve?') && Approve(val.ID);
                            }}
                          >
                            Approve
                          </button>
                        )}
                      </td>
                    ) : null}
                  </tr>

                );
              })}
            </tbody>
          </table>
        </div>
      </div >
      {isLoading ?
        <div className='overlay'>
          <div className="loading-container">
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <p className='loading'>Loading</p>
          </div>
        </div> : null}
    </div >
  )
}

export default All_requests;